<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title style="color:#1C2546;margin-top:40px">Administrar creación de solicitudes</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat color="white">
            <v-divider ></v-divider>
        </v-toolbar>
          <v-alert type="success" :value='alertSucess' close-text="Cerrar">
            {{ message }}
        </v-alert> 
        <v-alert type="error" :value='alertError' close-text="Cerrar">
            {{ message }}
        </v-alert> 
        <v-tabs fixed-tabs>
            <!-- Tabs de la pantalla -->
            <v-tab>Personal</v-tab>
            <v-tab>Delegaciones de solicitudes</v-tab>
            <!-- Tabs -->
            <!-- Tab del personal al cual dale permisos -->
            <v-tab-item>
                <v-data-table :search="searchDisponibles" :headers="headers_disponibles"  :items="disponibles"  class="elevation-1">
                    <template v-slot:top>
                        <v-row justify="center">
                            <v-col cols="10" sm="10" md="10">
                                <v-text-field v-model="searchDisponibles" append-icon="mdi-magnify" label="Buscar">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon v-if="item.puesto_jefe != 'CEO'" small class="mr-2" @click="autorizeTemp(item)" >mdi-account-convert</v-icon>
                    </template>
                </v-data-table>
            </v-tab-item>
            <!-- Tab de personal con permisos -->
            <v-tab-item>
                <v-data-table  :search="searchAutorizados"  :headers="headers_autorizados"  :items="autorizados"  class="elevation-1">
                    <template v-slot:top>
                        <v-row justify="center">
                            <v-col cols="10" sm="10" md="10">
                                <v-text-field v-model="searchAutorizados" append-icon="mdi-magnify" label="Buscar">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small class="mr-2" @click="restoreAut(item)" >mdi-trash-can</v-icon>
                    </template>
                </v-data-table>
            </v-tab-item>
        </v-tabs>
        <!-- Dialogs -->
        <!-- Dialog de confirmar restaurar autorizacion -->
        <v-dialog v-model="ConfirmRestoreAut" max-width="590">
            <v-card>
              <v-card-title class="headline"> Eliminar permiso para crear solicitudes</v-card-title>
              <v-card-text> ¿Estás seguro que deseas eliminar la delegación de creación de solicitudes? </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="ConfirmRestoreAut = false">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="ConfirmRestoreAutorizacion">Confirmar</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog delegar solicitudes --> 
        <v-dialog v-model="ConfirmAutTem" max-width="590">
            <v-card>
              <v-card-title class="headline"> Delegar creación de solicitudes </v-card-title>
              <v-card-text> Delegar solicitudes de : {{empleado}}</v-card-text>
              <v-card-text>
                 <v-select prepend-icon="mdi-account" v-model="id_crea_solicitud" :items="deudores2" item-text="nombre" item-value="id" label="Delegar a "  filled ></v-select>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="ConfirmAutTem = false" >Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="ConfirmDelegarSol" >Confirmar</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
         <!-- Dialog de confirmar delegar solicitudes --> 
        <v-dialog v-model="ConfirmDelSol" max-width="590">
            <v-card>
              <v-card-title class="headline"> </v-card-title>
              <v-card-text>¿Estás seguro que desea delegar las creaciones de solicitudes?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="ConfirmDelSol = false" >Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="ConfirmDelegarTemp" >Confirmar</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog de empleados a cargo de un puesto -->
        <v-dialog v-model="checkEmp" max-width="60%">
            <v-card>
              <v-card-title class="headline">Empleados a Cargo</v-card-title>
              <v-card-text>
                 <v-data-table :search="searchEmpleados" :headers="headers_empleados" :items="empleadosACargo" class="elevation-1">
                    <template v-slot:top>
                        <v-row justify="center">
                            <v-col cols="10" sm="10" md="10">
                                <v-text-field v-model="searchEmpleados" append-icon="mdi-magnify" label="Buscar">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
              </v-card-text>
            </v-card>
        </v-dialog> 
    </div>
</template>

<script>
import axios from "axios";
import router from '../router/index.js';

export default {
    data(){
        return {
            searchDisponibles : '',
            searchAutorizados : '',
            headers_disponibles:[
                { text: "Personal",value: "nombre", sortable: true},
                { text: "Departamento",value: "departamento", sortable: true},
                { text: "Puesto",value: "puesto", sortable: true},
                { text: "Acciones", value: "actions", sortable: false }
            ],
            headers_autorizados:[
                { text: "Nombre Personal Delega", value: "nombre_empleado_delega", sortable: true },
                { text: "Nombre Personal Autorizado",value: "nombre_empleado_recibe", sortable: true},
                { text: "Acciones", value: "actions", sortable: false }
            ],
            disponibles: [],
            autorizados: [],
            alertSucess: false,
            message: '',
            alertError: false,
            ConfirmAutTem: false,
            ConfirmDelSol: false,
            ConfirmRestoreAut: false,
            selectedRow: null,
            checkEmp: false,
            searchEmpleados: '',
            headers_empleados: [
                { text: "Empleado",value: "empleado", sortable: true },
                { text: "Puesto",value: "puesto", sortable: true },
            ],
            empleadosACargo: [],
            empleado:'',
            deudores:[],
            id_crea_solicitud:0,
            deudores2:[]
        }
    },
    mounted() {
        // Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;
        axios.interceptors.response.use(function (response){
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        });
        // End config for axios
        this.getDisponibles();
        this.getAutorizados();
    },
    methods: {
        getDisponibles() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/usuarios").then(res => {
                this.disponibles = res.data;
                this.deudores= res.data;
            });
        },
        getAutorizados() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/delegar/delegadosSolicitudes").then(res => {this.autorizados = res.data;});
        },
        autorizeTemp(item){
            this.alertSucess=false
            this.alertError = false;
            this.selectedRow = item;
            this.empleado=item.nombre
            this.id_crea_solicitud=''
            this.deudores2 = this.deudores.filter(deudor => deudor.id!= item.id);
            this.ConfirmAutTem = true;
        },
        ConfirmDelegarSol(){  
           this.ConfirmAutTem  = false
           this.ConfirmDelSol = true;
        },
        ConfirmDelegarTemp(){
           axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/delegar/creasolicitud",{ id_delega: this.selectedRow.id, id_recibe: this.id_crea_solicitud }).then(res => {
                this.ConfirmDelSol = false;
                this.getDisponibles();
                this.getAutorizados();
                this.message = res.data.message;
                if(res.data.message=='Ya existen una delegacion activa, no se puede delegar nuevamente')this.alertError = true;
                else this.alertSucess = true;
            })
        },
        restoreAut(item){
            this.alertSucess=false
            this.alertError = false;
            this.selectedRow = item;
            this.ConfirmRestoreAut = true;
        },
        ConfirmRestoreAutorizacion(){
            axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/delegar/desautorizar",{id_delega: this.selectedRow.id_usuario_delega, id_recibe: this.selectedRow.id_empleado_recibe, complete_row: this.selectedRow}).then(res => {
                this.getDisponibles();
                this.getAutorizados();
                this.message = res.data.message;
                this.alertSucess = true;
                this.ConfirmRestoreAut = false;
            })
        },
    }  
}
</script>
<style></style>